// @flow

import * as React from "react";

import AnimateHeight from "../atoms/AnimateHeight";
import Icon from "../atoms/Icon";

type PropsType = {
    title: string | React.Node,
    subtitle: string | React.ReactNode,
    content?: string,
    small?: boolean,
    children?: string | React.Node,
    active?: boolean,
    isOpen?: boolean,
    setIsOpen?: () => void,
};

const Accordion = (props: PropsType): React.Node => {
    const [nativeIsOpen, nativeSetIsOpen] = React.useState(props.active);
    const isHtmlContent = typeof props.content === "string";

    const isOpen = props.isOpen != null ? props.isOpen : nativeIsOpen;
    const setIsOpen =
        props.setIsOpen != null ? props.setIsOpen : nativeSetIsOpen;

    const handleTitleClick = e => {
        setIsOpen(a => !a);
        e.preventDefault();
    };
    return (
        <div
            className={`accordion ${props.small ? "accordion--small" : ""} ${
                isOpen ? "accordion--active" : ""
            }`}
        >
            <button className="accordion__title" onClick={handleTitleClick}>
                <div className="accordion__title__inner__wrapper">
                    <h4 className="accordion__title__inner heading-4">
                        {props.title}
                    </h4>
                    <div
                        className={`accordion__title__inner__subtitle${
                            !props.subtitle
                                ? " accordion__title__inner__subtitle--empty"
                                : ""
                        }`}
                    >
                        {props.subtitle}&nbsp;
                    </div>
                </div>
                {props.small ? (
                    <Icon name={`${isOpen ? "chevron-up" : "chevron-down"}`} />
                ) : (
                    <Icon name={`${isOpen ? "minus" : "plus"}`} />
                )}
            </button>
            <div className="accordion__content">
                <AnimateHeight
                    duration={500}
                    hideOverflow
                    height={isOpen ? null : 0}
                >
                    <div
                        style={{
                            transition: "300ms ease all",
                            opacity: isOpen ? 1 : 0,
                        }}
                    >
                        {isHtmlContent ? (
                            <div
                                className="accordion__content__inner rich-text-content"
                                dangerouslySetInnerHTML={{
                                    __html: props.content,
                                }}
                            ></div>
                        ) : (
                            <div className="accordion__content__inner">
                                {props.children || props.content}
                            </div>
                        )}
                    </div>
                </AnimateHeight>
            </div>
        </div>
    );
};

export default Accordion;
